// PetekB2B Tema Dosyası
const theme = {
  colors: {
    primary: '#E74C3C', // Kırmızı - Ana tema rengi (logo ile aynı)
    secondary: '#333333', // Koyu gri
    accent: '#F39C12', // Turuncu - Vurgu rengi
    lightGray: '#F5F5F5', // Açık gri - Arka plan rengi
    darkGray: '#555555', // Koyu gri - Metin rengi
    white: '#FFFFFF', // Beyaz
    black: '#000000', // Siyah
  },
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Open Sans', sans-serif",
  },
  fontSizes: {
    small: '0.875rem',
    normal: '1rem',
    medium: '1.25rem',
    large: '1.5rem',
    xlarge: '2rem',
    xxlarge: '2.5rem',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    wide: '1200px',
  },
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: '4px',
  transition: 'all 0.3s ease-in-out',
};

export default theme; 